import React, { ReactNode } from "react";
import { useForm } from "@inertiajs/react";
import { password_path } from "@/routes";
import { Box, Flex, Heading, VStack, Input, Button, Text } from "@chakra-ui/react";
import { Field } from "@/components/ui/field";
import DefaultLayout from "@/components/layouts/DefaultLayout";
import { RailsErrors, extractErrorMessages, hasErrors } from "@/util/errors";

interface EditProps {
  token: string;
  errors?: RailsErrors;
}

const Edit = ({ token, errors = {} }: EditProps) => {
  const { data, setData, patch, processing } = useForm({
    password: "",
    password_confirmation: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    patch(password_path(token));
  };

  return (
    <Flex minH="100vh" alignItems="center" justifyContent="center" bg="gray.50">
      <Box maxW="md" w="full">
        <VStack gap={8}>
          <Heading as="h2" size="2xl" textAlign="center" color="gray.900" mt={6}>
            Reset your password
          </Heading>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <VStack gap={6} w="full">
              {hasErrors(errors) && (
                <Box bg="red.50" borderWidth="1px" borderColor="red.200" borderRadius="md" p={4} w="full">
                  <VStack as="ul" gap={1} alignItems="flex-start">
                    {extractErrorMessages(errors).map((error, index) => (
                      <Text as="li" key={index} fontSize="sm" color="red.600">
                        {error}
                      </Text>
                    ))}
                  </VStack>
                </Box>
              )}

              <Field label="New Password" srOnly htmlFor="password">
                <Input
                  id="password"
                  name="password"
                  type="password"
                  required
                  placeholder="New password"
                  value={data.password}
                  onChange={(e) => setData("password", e.target.value)}
                />
              </Field>

              <Field label="Confirm Password" srOnly htmlFor="password_confirmation">
                <Input
                  id="password_confirmation"
                  name="password_confirmation"
                  type="password"
                  required
                  placeholder="Confirm new password"
                  value={data.password_confirmation}
                  onChange={(e) => setData("password_confirmation", e.target.value)}
                />
              </Field>

              <Button
                type="submit"
                disabled={processing}
                w="full"
                bg="primary-base"
                color="on-primary-base"
                _hover={{ bg: "primary-hover" }}
                cursor="pointer"
              >
                {processing ? "Updating..." : "Update password"}
              </Button>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Flex>
  );
};

Edit.layout = (page: ReactNode) => <DefaultLayout>{page}</DefaultLayout>;

export default Edit;
